import ReservationIndexVue from "@/views/reservation/ReservationIndex.vue";

const reservation = [
    {
        path: '/reservation',
        name: 'reservation',
        component: ReservationIndexVue
    }
]

export default reservation;